import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom';
import DOMPurify from 'dompurify';

export default function Blogcat() {
  const { postSlug } = useParams()
  const [posts, setPosts] = useState({})
  useEffect(() => {
    const postData = async () => {
      await fetch(`https://dunya-course-finder-blogs.vercel.app/api/auth/getpost/${postSlug}`, {
        method: "GET",
      })
        .then((res) => res.json())
        .then((data) => setPosts(data));
    };
    postData();
  }, [postSlug]);
  const sanitizedContent = { __html: DOMPurify.sanitize(posts.content) };
  return (
    <div>
      {/* header */}
      <div style={{ backgroundColor: "#212B36" }}>
        <h1 className="text-white text-center" style={{ padding: "100px 0" }}>
          {posts.title}
        </h1>
      </div>

      <div className="container blog-container">
        <div className='mt-5' dangerouslySetInnerHTML={sanitizedContent}></div>
      </div>
    </div>
  )
}
